import { apiV1 } from './api';
import { encodeQueryArray } from '../utils';

const getQuotes = (page = 1, search, isFilterDisabled) =>
  apiV1
    .get(
      `/expected_quotes?page=${page}&by_keywords=${search.keywords || ''}&by_delay=${search.delay ||
        ''}${encodeQueryArray('by_tags', search.tags)}&ignore_operator_filter=${isFilterDisabled}`,
    )
    .then(({ data }) => data);

export const expectedQuotesAPI = {
  getQuotes,
};
